import React from 'react'
import 'antd/dist/antd.css'

import './styles.less'

import { BrowserRouter } from 'react-router-dom'

import Routes from './routes'

function App() {
  return (
    <div className='App'>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </div>
  )
}

export default App
